<script src="../../api.js"></script>
<template>
  <div class="table-container">
    <div class="flex-between thead border-bottom" >
      <!--广告主 价格 支付方式 限额/数量 交易 0手续费-->
      <p class="inline-block th">{{ $t("400137") }}</p>
      <p class="inline-block th">{{ $t("400118") }}</p>
      <p class="inline-block th">{{ $t("400138") }}</p>
      <p class="inline-block th">{{ $t("400125") }}</p>
      <p class="inline-block th">
        {{ $t("400139") }}
        <em class="normal buyColor inline-block">{{ $t("400108") }}</em>
      </p>
    </div>
    <div class="tbody">
      <div
        class="tr border-bottom"
        :class="{ activeTr: item.active }"
        v-for="(item, index) in listData.items"
        :key="index"
      >
        <div class="flex-between flex-start newStyle">
          <div class="td inline-block">
            <div
              class="name bold pointer"
              :data-icon="item.nickname ? item.nickname[0] : ''"
              @click="$router.push({ path: `/addetail/${item.userId}` })"
            >
              {{ item.nickname }}
            </div>
            <div class="success-percent">
              {{ $t("400116", { amount: item.thirtyOrderQuantity }) }} |
              {{
                $t("400117", {
                  num: fixNumberCopy(numMultiply(item.thirtyCloseRate, 100), 2),
                })
              }}
            </div>
          </div>
          <div class="td inline-block">
            <p class="price bold" :data-unit="item.fiat">{{ item.price }}</p>
          </div>
          <div class="td inline-block">
            <p class="num amount">
              {{ $t("400140") }}&nbsp;&nbsp;<span class="inline-block uppercase"
                >{{ item.txAmount }} {{ item.currency }}</span
              >
            </p>
            <p class="num">
              {{ $t("400141") }}&nbsp;&nbsp;<span class="inline-block"
                >{{ item.fiatSymbol }}{{ item.minAmount }}</span
              >
              -
              <span class="inline-block"
                >{{ item.fiatSymbol }}{{ item.maxAmount }}</span
              >
            </p>
          </div>
          <div class="td inline-block">
            <span
              class="inline-block pay-item"
              v-for="inner in item.payments"
              :key="inner.value"
            >
              <em
                class="inline-block normal"
                :style="{ backgroundColor: inner.extra }"
              ></em
              >{{ inner.key }}
            </span>
          </div>
          <div class="td inline-block">
            <span
              class="block pay-button pointer"
              :class="status == 0 ? 'buyBgColor' : 'sellBgColor'"
              v-if="item.condition == 1"
              @click="handleClick(item, index)"
              >{{ status == 0 ? $t("400129") : $t("400130") }}
              {{ item.currency | upcase }}</span
            >
            <!--不满足广告方要求-->
            <el-button v-else disabled>{{ $t("400188") }}</el-button>
            <!--          <ContentPicker ref="ContentPicker" :showPopover="showPopover" :item="item" :status="status">
                        <span class="block pay-button pointer" :class="status == 0 ? 'buyBgColor' : 'sellBgColor'" @click="handleClick(item)">{{ status == 0 ? '购买' : '出售' }}{{ item.currency | upcase }}</span>
                      </ContentPicker>-->
          </div>
        </div>
        <div class="detail-model relative" v-if="item.active">
          <ContentPickerCopy
            :item="item"
            :status="status"
            @closeModel="closeModel"
          ></ContentPickerCopy>
        </div>
      </div>
    </div>
    <el-empty
      :description="$t('400025')"
      class="empty-box"
      v-show="listData.items.length == 0"
    >
      <svg slot="image" class="icon empty-icon" aria-hidden="true">
        <use
          :xlink:href="
            styleType == 'sunlight' ? '#icon-jilu1' : '#icon-zanwujilu'
          "
        ></use>
      </svg>
    </el-empty>
    <el-pagination
      layout="prev, pager, next"
      :total="listData.total"
      :page-size="10"
      :current-page="page"
      background
      @current-change="handleCurrentChange"
      style="text-align: right; margin-top: 24px"
    ></el-pagination>
    <tipModel
      v-if="tipModelShow"
      :cancelButton="
        tipType == 3 || tipType == 5 || tipType == 6 || tipType == 7
          ? false
          : true
      "
      :confirmButton="true"
      :confirmText="
        tipType == 1
          ? $t('400099')
          : tipType == 4
          ? $t('400142')
          : tipType == 7
          ? $t('400133')
          : $t('400143')
      "
      :cancelText="$t('400096')"
      @sureTip="sureFun"
      @closeTip="tipModelShow = false"
    >
      <p style="font-size: 14px; line-height: 21px; margin: 16px 0 32px">
        {{ tipMessage }}
      </p>
    </tipModel>
    <!--设置昵称弹框-->
    <div class="model" v-if="nicknameModel">
      <div class="set-nickname-model">
        <!--设置昵称-->
        <p class="title flex-between bold">
          {{ $t("400103") }}
          <i class="el-icon-close pointer" @click="nicknameModel = false"></i>
        </p>
        <div class="form">
          <!--请设置您的账号昵称,建议不要使用真实姓名.昵称长度2~10个字符.-->
          <span class="block">{{ $t("400104") }}</span>
          <el-input
            class="nickname-input"
            :placeholder="$t('400103')"
            maxlength="10"
            minlength="2"
            v-model="nickname"
          ></el-input>
          <!--设置昵称-->
          <el-button
            class="form-btn"
            :disabled="nickname == '' || nickname.length < 2"
            @click="submitNickname"
          >
            {{ $t("400103") }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "../../api";
import urls from "@/utils/baseUrl";
import tipModel from "@/components/publicModel/tipModel";
import { fixNumberCopy, fixNumber, numMultiply, secTotime } from "@/plugins/methods";
import { mapGetters } from "vuex";
import ContentPickerCopy from "@/views/buycoin/buycoin/components/ContentPickerCopy";

export default {
  props: {
    listData: Object,
    status: Number,
    page: Number,
  },
  components: {
    tipModel,
    ContentPickerCopy,
  },
  data() {
    return {
      userPaymentId: null,
      linkUrl: urls.linkUrl,
      nodata: require("../../../../assets/img/nodata.png"),
      nodata_hei: require("../../../../assets/img/nodata_hei.png"),
      tipMessage: "tipMessagetipMessagetipMessage",
      tipType: "",
      tipModelShow: false,
      nicknameModel: false,
      nickname: "",
    };
  },
  computed: {
    ...mapGetters(["token", "styleType", "C2CUserInfo"]),
  },
  created(){
    if(this.token){
        this.$store.dispatch("GetC2CUserInfo");
    }
  },
  methods: {
    numMultiply(arg1, arg2) {
      return numMultiply(arg1, arg2);
    },
    fixNumberCopy(value, unit) {
      return fixNumberCopy(value, unit);
    },
    fixNumber(value, unit) {
      return fixNumber(value, unit);
    },
    sureFun() {
      this.tipModelShow = false;
      this.tipMessage = "";
      if (this.tipType == 1) {
        window.location.href = this.linkUrl + "/userCenter/identity";
      } else if (this.tipType == 4) {
        this.$router.push("/myorder");
      }
    },
    submitNickname() {
      api.nicknameChange({ nickname: this.nickname }).then((res) => {
        this.nicknameModel = false;
        this.$store.dispatch("GetC2CUserInfo");
        this.$notify({
          message: this.$t("400106"), // 设置成功
          iconClass: "iconfont icon-wancheng-2",
          customClass: "successIcon flex-center",
          showClose: false,
          duration: 2000,
          // position:this.isDirection ? 'top-left' : 'top-right'
        });
      });
    },
    handleClick(item, index) {
      this.$firebase.logEvent('p2p_button',{button:this.status == 0 ? 'buy' : 'sell'})
      if (!this.token) {
        window.location.href = this.linkUrl + "/login";
        return false;
      }
      api.verifyOrder(item.id).then((res) => {
        console.log(res);
        if (res.isAuth == 0) {
          this.tipModelShow = true;
          this.tipType = 1;
          this.tipMessage = this.$t("400144"); // 开始交易前，请先完成身份认证
        } else if (
          this.C2CUserInfo &&
          this.C2CUserInfo.tradableCurrency != item.fiat.toUpperCase()
        ) {
          this.tipModelShow = true;
          this.tipType = 7;
          this.tipMessage = this.$t("400187"); // 根据SuperEx身份认证的国家或地区和平台的运营规范，请您选择支持的法币进行交易
        } else if (res.isNickname != 1) {
          this.nicknameModel = true;
          this.tipType = 2;
        } else if (res.isCancelUpperLimit == 1) {
          this.tipModelShow = true;
          this.tipType = 3;
          this.tipMessage = this.$t("400145", {num: res.cancelUpperLimit, time: secTotime(res.punishedTime)}); // 您的今日订单取消次数已超{num}次，无法继续交易，请在{time}之后再尝试
        } else if (res.isUnderwayOrderUpperLimit == 1) {
          this.tipModelShow = true;
          this.tipType = 4;
          this.tipMessage = this.$t("400146", { num: 1 }); // 您的待处理订单已达上限（{num}个）。请先完成正在进行的订单。
        } else if (res.isMerchantUnderwayOrderUpperLimit == 1) {
          this.tipModelShow = true;
          this.tipType = 5;
          this.tipMessage = this.$t("400147"); // 该广告主待处理订单已达上限，请稍后操作或尝试其他广告。
        } else if (res.isRegisterTime == 0) {
          this.tipModelShow = true;
          this.tipType = 6;
          this.tipMessage = this.$t("400148"); // 您未满足广告方要求，请尝试其他广告
        } else {
          this.tipModelShow = false;
          this.tipType = "";
          this.tipMessage = "";
          this.listData.items.forEach((v) => {
            if (v.active !== this.listData.items[index].active) {
              v.active = false;
            }
          });
          item.active = !item.active;
        }
      });
    },
    closeModel(item) {
      item.active = !item.active;
      // this.$emit("search", {page: 1});
    },
    handleCurrentChange(v) {
      var container = document.querySelector("body");
      container.scrollTop = 0;
      this.$emit("search", { page: v });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";

.table-container {
  margin: 32px auto 0;
  width: 1200px;
  .border-bottom {
    border-bottom: 1px solid;
    @include border_color("border-color-normal");
  }

  .thead {
    .th {
      width: calc(70% / 3);
      font-size: $font-size-mini;
      @include font_color("font-color-1");
      padding: 14px 0;

      &:nth-child(2) {
        width: 15%;
      }

      &:last-child {
        text-align: end;
        width: 15%;

        em {
          padding: 4px 10px;
          border-radius: 4px;
          background-color: rgba(12, 170, 109, 0.1);
        }
      }
    }
  }

  .tbody {
    .tr.activeTr {
      @include background_color("background-color-6");
    }
    .tr {
      align-items: flex-start;
      &:hover {
        @include background_color("background-color-6");
      }
      .td {
        width: calc(70% / 3);
        padding: 24px 0;

        &:nth-child(2) {
          width: 15%;
        }

        &:last-child {
          text-align: end;
          width: 15%;
          ::v-deep .el-button {
            padding: 7px 8px;
            width: 100%;
            @include background_color("button-bg-nickName");
            border: none;
            @include font_color("font-color-1");
            white-space: pre-wrap;
          }
        }
      }

      .name {
        font-size: $font-size-small;
        margin-bottom: 10px;
        @include font_color("font-color");

        &::before {
          display: inline-block;
          content: attr(data-icon);
          text-align: center;
          height: 20px;
          width: 20px;
          line-height: 20px;
          border-radius: 50%;
          background: #ffc72b;
          color: $font-color-3;
          font-size: $font-size-mini;
          margin-right: 12px;
        }
      }

      .success-percent {
        margin-left: 32px;
        font-size: $font-size-mini;
        @include font_color("font-color-1");
      }

      .price {
        font-size: $font-size-big;
        @include font_color("font-color");

        &::after {
          content: attr(data-unit);
          text-transform: uppercase;
          margin-left: 4px;
          display: inline-block;
          vertical-align: 0px;
          @include font_color("font-color-1");
          font-size: $font-size-mini;
        }
      }

      p.num {
        font-size: $font-size-mini;
        @include font_color("font-color-1");

        span {
          font-size: $font-size-small;
          @include font_color("font-color");
        }
      }

      .amount {
        margin-bottom: 11px;
      }

      .pay-item {
        font-size: $font-size-mini;
        margin-right: 24px;
        @include font_color("font-color");

        em {
          width: 4px;
          height: 12px;
          border-radius: 2px;
          vertical-align: -2px;
          margin-right: 4px;
        }
      }

      .pay-button {
        padding: 8px;
        width: 100%;
        border-radius: 2px;
        text-align: center;
        color: $font-color-white;
      }
    }
  }

  .set-nickname-model {
    width: 536px;
    height: 309px;
    border-radius: 4px;
    @include background_color("dialog-bg");
    padding: 48px;

    .title {
      margin-bottom: 32px;
      font-size: $font-size-normal;

      i {
        font-weight: normal;
      }
    }

    .nickname-input {
      margin: 12px 0 52px;

      ::v-deep .el-input__inner {
        background-color: transparent;
      }
    }

    ::v-deep .el-button.is-disabled.form-btn {
      @include background_color("button-bg-disabled");
      @include font_color("font-color-1");
    }
  }

  .empty-box {
    margin-top: 120px;
  }
}
.newStyle{
    padding: 0 16px !important;
}
//波斯语镜像
[dir="rtl"] .name {
  font-size: $font-size-small;
  margin-bottom: 10px;
  @include font_color("font-color");

  &::before {
    display: inline-block;
    content: attr(data-icon);
    text-align: center;
    height: 20px;
    width: 20px;
    line-height: 20px;
    border-radius: 50%;
    background: #ffc72b;
    color: $font-color-3;
    font-size: $font-size-mini;
    margin-left: 12px;
  }
}
[dir="rtl"] .price {
  font-size: $font-size-big;
  @include font_color("font-color");

  &::after {
    content: attr(data-unit);
    text-transform: uppercase;
    margin-right: 4px;
    display: inline-block;
    vertical-align: 0px;
    @include font_color("font-color-1");
    font-size: $font-size-mini;
  }
}
[dir="rtl"] .pay-item {
  font-size: $font-size-mini;
  margin-right: 24px;
  @include font_color("font-color");

  em {
    width: 4px;
    height: 12px;
    border-radius: 2px;
    vertical-align: -2px;
    margin-left: 4px;
  }
}
</style>
